import { useState } from "react";
import { NativeSelect } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { BaseData, Optional } from "../../../types/common";
import Popup from "../Popup";
import { InputWrapper, ISystemModal, PopupBody } from "../tables/SettingStaticTable";

const SensorModal = <T extends Optional<BaseData, "id">>({
	inputData,
	modalButtonText,
	settingName,
	tableData,
	setSetting,
}: ISystemModal<T>) => {
	const [modalSelectedType, setModalSelectedType] = useState<string>();

	const handleSubmit = () => {
		if (modalSelectedType !== undefined) setSetting(settingName as keyof T, [...tableData, parseInt(modalSelectedType)] as T[keyof T]);
		else {
			notifications.show({ title: "Info", message: "Please select sensor", color: "blue", autoClose: 5000 });
			return false;
		}

		return true;
	};

	return inputData.sensors ? (
		<Popup title={""} modalButtonText={modalButtonText} handleSubmit={handleSubmit}>
			<PopupBody>
				<InputWrapper>
					<h4>Sensor</h4>
					<NativeSelect
						required
						w={"70%"}
						placeholder="Select sensor"
						data={[
							{ value: "-1", label: "Select sensor" },
							...inputData.sensors.map((sensor, i) => ({
								value: i.toString(),
								label: sensor.info ? sensor.info.name : sensor.id.toString(),
							})),
						]}
						onChange={(e) => {
							e.target.value !== "-1" && inputData.sensors
								? setModalSelectedType(inputData.sensors[e.target.value as unknown as number].id.toString())
								: setModalSelectedType(undefined);
						}}
						defaultChecked={false}
					/>
				</InputWrapper>
			</PopupBody>
		</Popup>
	) : null;
};

export default SensorModal;
